"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnouncementServiceStub = void 0;
const faker = __importStar(require("faker"));
const generateFakeAnnouncement = () => ({
    attachmentUrls: Array.from({
        length: 2,
    }).map(() => faker.internet.url()),
    _id: faker.random.alphaNumeric(20),
    companyId: faker.random.alphaNumeric(20),
    body: faker.random.words(150),
    subject: faker.random.words(10),
    dateOfAnnouncement: faker.date.recent(),
    createdByUser: {
        _id: faker.random.alphaNumeric(20),
        firstName: faker.name.firstName(),
        secondName: faker.name.firstName(),
        thirdName: "",
        familyName: faker.name.lastName(),
        userId: faker.random.alphaNumeric(20),
    },
    includeShareholders: faker.random.boolean(),
    includeNoteholders: faker.random.boolean(),
    includeOptionholders: faker.random.boolean(),
    selectedShareClasses: faker.random.boolean()
        ? [{ shareClassId: faker.random.alphaNumeric(20), name: faker.random.word() }]
        : undefined,
    shareholderIds: Array.from({
        length: 5,
    }).map(() => faker.random.alphaNumeric(20)),
});
class AnnouncementServiceStub {
    async getCompanyAnnouncements(companyId) {
        if (companyId) {
            const announcementList = Array.from({
                length: 30,
            }).map(() => generateFakeAnnouncement());
            return {
                status: true,
                payload: { announcementList, count: 30 },
                message: "",
            };
        }
        return {
            status: false,
            payload: null,
            message: "",
        };
    }
    async getAnnouncement(companyId) {
        if (companyId) {
            return {
                status: true,
                payload: generateFakeAnnouncement(),
                message: "",
            };
        }
        return {
            status: false,
            payload: null,
            message: "",
        };
    }
    async getAttachmentSignedUrl() {
        return {
            status: true,
            payload: faker.internet.url(),
            message: "",
        };
    }
}
exports.AnnouncementServiceStub = AnnouncementServiceStub;
//# sourceMappingURL=AnnouncementServiceStub.js.map